import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';

const Container = styled.div`
  height: 100%;
  padding: 28px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  font-family: Hind;
  font-style: normal;
  .infoContain {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    h3 {
      max-width: 324px;
      font-size: 20px;
      font-weight: 600;
      line-height: 130%;
      text-align: center;
      white-space: normal;
    }
    p {
      font-size: 14px;
      font-weight: 400;
      line-height: 26px;
      text-align: center;
      white-space: normal;
    }
  }
`;

const Img = styled.div`
  background-image: url(${({ src }) => src});
  background-size: contain;
  width: 141px;
  height: 95px;
  margin-top: 14px;
`;

const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-top: 16px;
`;

const Button = styled.div`
  width: ${({ width }) => width};
  height: 40px;
  border-radius: ${({ borderRadius }) => borderRadius || '8px'};
  font-size: ${({ fontSize }) => fontSize || '16px'};
  font-weight: ${({ fontWeight }) => fontWeight || '600'};
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  &.solidButton {
    background-color: ${getColor('primary')};
    color: ${select('white')};
    &:hover {
      background-color: ${select('orangeDark')};
    }
  }
  &.noBorderButton {
    background-color: ${select('transparent')};
    &:hover {
      background-color: ${select('lightGray')};
    }
  }
`;

export { Container, ButtonContainer, Img, Button };
